import React, { useState } from 'react';
import ConversationsDataTable from './ConversationsDataTable';

export default function ConversationsView({ onError, refreshToken }) {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [appliedFrom, setAppliedFrom] = useState('');
  const [appliedTo, setAppliedTo] = useState('');

  const applyFilters = (e) => {
    e.preventDefault();
    setAppliedFrom(dateFrom);
    setAppliedTo(dateTo);
  };

  const clearFilters = () => {
    setDateFrom('');
    setDateTo('');
    setAppliedFrom('');
    setAppliedTo('');
  };

  const hasFilter = Boolean(appliedFrom || appliedTo);

  return (
    <>
      <div className="card card-primary card-outline">
        <div className="card-header">
          <h3 className="card-title">
            <i className="fas fa-filter mr-1" />
            Filter by date
          </h3>
        </div>
        <form className="card-body" onSubmit={applyFilters}>
          <div className="row align-items-end">
            <div className="col-md-4">
              <label className="text-sm">From</label>
              <input
                type="date"
                className="form-control"
                value={dateFrom}
                max={dateTo || undefined}
                onChange={(e) => setDateFrom(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="text-sm">To</label>
              <input
                type="date"
                className="form-control"
                value={dateTo}
                min={dateFrom || undefined}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-primary mr-2">
                Apply
              </button>
              {hasFilter && (
                <button type="button" className="btn btn-default" onClick={clearFilters}>
                  Clear
                </button>
              )}
            </div>
          </div>
        </form>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">
            <i className="fas fa-table mr-1" />
            All conversations
          </h3>
        </div>
        <div className="card-body p-0">
          <ConversationsDataTable
            dateFrom={appliedFrom}
            dateTo={appliedTo}
            refreshToken={refreshToken}
            onError={onError}
          />
        </div>
      </div>
    </>
  );
}
